import PropTypes from 'prop-types';
import React from 'react';
import { optionalAttribute } from 'utils/jsx';
import localize from 'components/Localize/Localize';

import styles from './ProductAvailability.css';
import translations from './translations';

class ProductAvailability extends React.Component {
  renderLimitedMessaging() {
    if (!this.props.isLimited) {
      return null;
    }

    return <span className={styles[`limited`]}>{this.props.t.limited}</span>;
  }

  renderShippingStatus() {
    if (!this.props.isReadyToShip) {
      return <span>{`${this.props.t.shipsBy} ${this.props.date}`}</span>;
    }

    return <span>{this.renderLimitedMessaging()}{this.props.t.readyToShip}</span>;
  }

  render() {
    const className = optionalAttribute(`className`, this.props.className, this.props.className);

    return (
      <span {...className}>
        {this.renderShippingStatus()}
      </span>
    );
  }
}

ProductAvailability.propTypes = {
  className:  PropTypes.string,
  date: PropTypes.string,
  isLimited: PropTypes.bool,
  isReadyToShip: PropTypes.bool.isRequired,
  t: PropTypes.shape({
    limited: PropTypes.string,
    readyToShip: PropTypes.string.isRequired,
    shipsBy: PropTypes.string.isRequired,
  }),
};

ProductAvailability.defaultProps = {
  fetchingShipDate: false,
  isLimited: false,
};

export default localize(ProductAvailability, translations);
